import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, Legend } from 'recharts';
import '../../css/Admin.css';

const AdminStatsNotes = ({ userStats, title = "Notes et Statistiques" }) => {
  const [open, setOpen] = useState(true);

  if (!userStats || userStats.length === 0) return <p>Aucune donnée disponible.</p>;

  // Agrégation des données par semaine
  const chartData = Object.values(
    userStats.reduce((acc, s) => {
      const week = new Date(s.weekStart).toLocaleDateString();
      if (!acc[week]) acc[week] = {
        week,
        nbNotesCreated: 0,
        nbNotesUpdated: 0,
        nbNotesOpened: 0,
        nbStatsOpened: 0,
        nbHistoryOpened: 0
      };
      acc[week].nbNotesCreated += s.nbNotesCreated || 0;
      acc[week].nbNotesUpdated += s.nbNotesUpdated || 0;
      acc[week].nbNotesOpened += s.nbNotesOpened || 0;
      acc[week].nbStatsOpened += s.nbStatsOpened || 0;
      acc[week].nbHistoryOpened += s.nbHistoryOpened || 0;
      return acc;
    }, {})
  );

  return (
    <div className="admin-notes-container">
      <h2 className="notes-chart-title" onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        {title} {open ? '▼' : '▲'}
      </h2>

      {open && (
        <div className="notes-charts-wrapper">

          {/* Simple Bar Chart : Notes créées vs modifiées */}
          <div className="notes-bar-chart">
            <h3 className="notes-chart-subtitle">Notes créées vs modifiées</h3>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="nbNotesCreated" fill="#3b82f6" name="Créées" />
                <Bar dataKey="nbNotesUpdated" fill="#f59e0b" name="Modifiées" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Line Chart : Notes ouvertes / Stats ouvertes / History ouvertes */}
          <div className="notes-line-chart">
            <h3 className="notes-chart-subtitle">Activité utilisateur</h3>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Legend verticalAlign="top" />
                <Line type="monotone" dataKey="nbNotesOpened" stroke="#10b981" name="Notes ouvertes" />
                <Line type="monotone" dataKey="nbStatsOpened" stroke="#6366f1" name="Stats ouvertes" />
                <Line type="monotone" dataKey="nbHistoryOpened" stroke="#f43f5e" name="History ouvertes" />
              </LineChart>
            </ResponsiveContainer>
          </div>

        </div>
      )}
    </div>
  );
};

export default AdminStatsNotes;
